import { render, staticRenderFns } from "./DashboardShare.vue?vue&type=template&id=3cca0f7c&scoped=true"
import script from "./DashboardShare.vue?vue&type=script&lang=js"
export * from "./DashboardShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca0f7c",
  null
  
)

export default component.exports